import { AppNavParams } from '@euler/app/Routes';
import { useServiceFactory } from '@euler/services/factory';
import { useNavigation } from '@react-navigation/native';
import { StackNavigationProp } from '@react-navigation/stack';
import { memo } from 'react';
import { TouchableOpacity } from 'react-native';

const kCameraTestForQrcode = true;

export const CameraTestButton = memo(() => {
  const navigation = useNavigation<StackNavigationProp<AppNavParams>>();
  const { mediaFileService } = useServiceFactory();
  return (
    <TouchableOpacity
      css={`
        position: absolute;
        right: 44px;
        bottom: 144px;
        background-color: gray;
        border-radius: 64px;
        width: 64px;
        height: 64px;
      `}
      onPress={() => {
        if (kCameraTestForQrcode) {
          navigation.push('_qrcodeScan', {
            onScan: value => {
              console.log('scan result: ', value);
            },
          });
          return;
        }

        navigation.push('_camera', {
          previewResult: true,
          onResult: async result => {
            console.log('camera result: ', JSON.stringify(result, null, 2));

            if (result.type === 'photo') {
              const res1 = await mediaFileService.upload(
                `file://${result.file.path}`,
                {
                  __local_test__: true,
                },
              );
              console.log('uploaded original image: ', res1);
              const res2 = await mediaFileService.upload(result.uri, {
                __local_test__: true,
              });
              console.log('uploaded processed image: ', res2);
            } else {
              const res1 = await mediaFileService.upload(result.uri, {
                __local_test__: true,
                videoRotate: result.rotate,
              });
              console.log('uploaded video: ', res1);
            }
          },
        });
      }}
    />
  );
});
